import { isMobile, isTablet } from 'react-device-detect';
import { Gift, GiftCategory, GiftKlydo } from '../../api/gift';
import { WizardStep } from '../../consts/wizardSteps';

export const getDeviceAppropriateAnimationUrl = (
  klydo: GiftKlydo | Partial<GiftKlydo>,
): string => {
  if (!klydo?.klydoAnimation) {
    return klydo?.loopUrl || '';
  }

  if (isMobile) {
    return klydo.klydoAnimation.s;
  }

  if (isTablet) {
    return klydo.klydoAnimation.m;
  }

  return klydo.klydoAnimation.l;
};

// A custom logo is an admin upload (sized or full): a logo URL that is not one
// of the category logos. Only the studio's admin form offers it, so the
// non-admin flow must never replace or drop it. Unknown until the categories
// load, so it is false until then.
export const isCustomPendulumLogo = (
  pendulumLogoUrl: string | undefined,
  giftCategories: GiftCategory[] | undefined,
): boolean => {
  const logoUrl = pendulumLogoUrl?.trim();
  return (
    !!logoUrl &&
    !!giftCategories &&
    !giftCategories.some(
      (category) => category.pendulumLogoUrl?.trim() === logoUrl,
    )
  );
};

// A logo gift is saved with no sender name on purpose (the admin form clears
// it when the logo option is picked), so the name is optional for it.
export const isSenderNameOptional = (
  pendulumLogoUrl: string | undefined,
  admin: boolean,
  giftCategories: GiftCategory[] | undefined,
): boolean =>
  !!pendulumLogoUrl &&
  (admin || isCustomPendulumLogo(pendulumLogoUrl, giftCategories));

// An admin-made greet (a custom logo, or a klydo in no category) has no
// occasion or klydo to pick that keeps it as it is, so Edit opens the text.
export const getEditGreetStep = (
  gift: Pick<Gift, 'klydoId' | 'pendulumLogoUrl'> | undefined,
  giftCategories: GiftCategory[] | undefined,
): WizardStep => {
  const klydoInCategory = (giftCategories ?? []).some((category) =>
    category.klydos?.some((klydo) => klydo.id === gift?.klydoId),
  );
  return isCustomPendulumLogo(gift?.pendulumLogoUrl, giftCategories) ||
    !klydoInCategory
    ? WizardStep.PERSONAL_GREET
    : WizardStep.OCCASION;
};
